import { Field, FieldProps } from 'formik';
import TextInput, { FieldSize } from '../../atoms/TextInput';
import { TextFieldContainer } from './TextField.styled';
import { CSSProperties } from 'react';

interface TextFieldProps {
  name: string;
  size: FieldSize;
  placeholder?: string;
  type?: string;
  disabled?: boolean;
  errorMessage?: string;
  styles?: CSSProperties;
}

const TextField = (props: TextFieldProps) => {
  return (
    <TextFieldContainer style={props.styles}>
      <Field name={props.name}>
        {(field: FieldProps) => (
          <TextInput
            name={props.name}
            size={props.size}
            placeholder={props.placeholder}
            paddingLeft={15}
            paddingRight={15}
            {...field}
            type={props.type ?? 'text'}
            errorMessage={props.errorMessage}
            disabled={props.disabled}
          />
        )}
      </Field>
    </TextFieldContainer>
  );
};

export default TextField;
